import request from '@/utils/request'

// 上报 现在扫脸 渠道选项
export function getFaceScanRtspMenu() {
  return request({
    url: '/faceScan/getFaceScanRtspMenu',
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/faceScan.js